import { makeStyles, createStyles, Theme } from '@material-ui/core/styles';

export const useStyles = makeStyles((theme: Theme) =>
    createStyles({
        mainContainer: {
            background: 'linear-gradient(180deg, #000000 0%, rgba(211, 47, 47, 0.72) 100%)',
            color: '#fff',
            width: '100%',
            textAlign: 'center'
        },
        informationContainer: {
            fontSize: '50px',
            marginLeft: '30px',
            [theme.breakpoints.down('xs')]:{
                fontSize:'25px'
            }
        },
        homeContainer: {
            margin: '20px 0 30px 0'
        },
        homeButton: {
            backgroundColor: '#D32F2F',
            color: '#fff',
            width: '250px',
            '&:hover': {
                backgroundColor: '#212121'
            }
        },
        errorCode: {
            fontSize: '160px',
            [theme.breakpoints.down('xs')]:{
                fontSize:'100px'
            }
        },
        verticalDivider: {
            borderLeft: '2px solid #fff',
            height: '400px',
            [theme.breakpoints.down('xs')]:{
                display:'none'
            }
        }
    })
);